import { OneServiceI18n } from './OneServiceI18n';

export const createI18n = (): OneServiceI18n => new OneServiceI18n();
export * from './BaseOneServiceI18n';
export * from './backends';
export * from './language-detectors';
